import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface RoleToggleOption {
  value: string;
  label: string;
}

@Component({
  selector: 'app-role-toggle-filter',
  templateUrl: './role-toggle-filter.component.html',
  styleUrls: ['./role-toggle-filter.component.scss'],
  standalone: false,
})
export class RoleToggleFilterComponent {
  /** Currently selected role filter value ('' = All). */
  @Input() value: string = '';

  /** Emit when the selected role filter changes. */
  @Output() valueChange = new EventEmitter<string>();

  /** Options to render. Default matches signature-role-matrix filter. */
  @Input() options: RoleToggleOption[] = [
    { value: '', label: 'All' },
    { value: 'ADMIN', label: 'Admin' },
    { value: 'EDITOR', label: 'Editor' },
    { value: 'MANAGER', label: 'Manager' },
    { value: 'OPERATOR_CP', label: 'Operator CP' },
    { value: 'OPERATOR_MCP', label: 'Operator MCP' },
    { value: 'COMPANY_SIGN_CERT', label: 'Company Sign Cert' },
    { value: 'VENDOR', label: 'Vendor' },
  ];

  onChange(newValue: string): void {
    this.value = newValue;
    this.valueChange.emit(newValue);
  }
}
